import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconTreasuremapBlack({
	size = "100",
	...props
}: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<g fill="#e42822">
				<path d="M16.11 14.53c.21-.04.42.11.45.32.04.21-.11.42-.32.45-.12.02-.25.03-.37.03-.22 0-.39-.18-.39-.39s.18-.39.39-.39c.08 0 .16 0 .24-.02M17.51 14.58c.16-.19.29-.4.38-.64.08-.2-.02-.43-.22-.51s-.43.02-.51.22q-.075.195-.21.36l-.04.05c-.14.16-.12.41.04.55s.41.12.55-.04Zm.43-2.1c-.08-.24-.2-.46-.35-.66a.395.395 0 0 0-.55-.07c-.17.13-.2.38-.07.55.1.13.17.27.22.42.07.21.29.32.49.25.21-.07.32-.29.25-.49Zm-1.59-1.45a2 2 0 0 0-.48-.05h-.22c-.22 0-.39.18-.39.39s.18.39.39.39h.22c.08 0 .16 0 .24.02h.06c.21.06.42-.07.47-.28a.39.39 0 0 0-.3-.47Zm-1.92-.05h-.61a.4.4 0 0 0-.4.39c0 .21.16.38.36.39h.64c.22 0 .39-.18.39-.39s-.18-.39-.39-.39Zm-1.49-.33c-.11-.09-.2-.2-.28-.31l-.03-.05a.39.39 0 0 0-.54-.14c-.19.11-.25.35-.14.54q.195.33.48.57c.17.14.41.12.55-.05s.12-.41-.05-.55Zm-.5-1.38c-.02-.25-.08-.5-.18-.72-.09-.2-.32-.29-.52-.2s-.29.32-.2.52c.06.15.1.3.11.46.02.22.2.38.42.36s.38-.2.36-.42Zm-1.2-1.8a2.2 2.2 0 0 0-.71-.21.39.39 0 0 0-.43.34c-.02.21.13.41.34.43.16.02.31.06.46.13.19.1.43.02.52-.18.1-.19.02-.43-.18-.52Zm-2.14.12c-.21.13-.4.3-.55.5-.13.17-.1.42.07.55s.42.1.55-.07c.1-.13.22-.24.35-.32a.4.4 0 0 0 .12-.54.4.4 0 0 0-.54-.12m-1 1.88v.61c0 .22.18.39.39.39s.39-.18.39-.39v-.61c0-.22-.18-.39-.39-.39s-.39.18-.39.39m-.03 1.74c-.04.16-.1.3-.18.44a.39.39 0 1 0 .66.42c.13-.21.23-.44.29-.69a.39.39 0 1 0-.76-.18Zm-.93 1.01c-.14.04-.28.07-.43.07h-.06a.39.39 0 0 0 0 .78h.06c.23 0 .45-.04.67-.11.21-.07.32-.29.25-.49a.385.385 0 0 0-.49-.25" />
			</g>
			<path
				fill="#e42822"
				d="M5.51 12.3c.22 0 .39.18.39.39s-.16.38-.36.39H5.2c-.22 0-.39-.18-.39-.39s.16-.38.36-.39h.34"
			/>
			<path d="M20.39 4.24c1.26 0 2.28 1.02 2.28 2.28 0 .22-.18.39-.39.39s-.39-.18-.39-.39c0-.83-.67-1.49-1.49-1.49-.22 0-.39-.18-.39-.39s.18-.39.39-.39ZM9.63 4.24c.22 0 .39.18.39.39s-.16.38-.36.39h-5.8c-.22 0-.39-.18-.39-.39s.16-.38.36-.39h5.8M16.46 4.24c.22 0 .39.18.39.39s-.16.38-.36.39h-5.7c-.22 0-.39-.18-.39-.39s.16-.38.36-.39h5.7" />
			<path d="M20.39 4.24c.22 0 .39.18.39.39s-.16.38-.36.39h-2.8099999999999996c-.22 0-.39-.18-.39-.39s.16-.38.36-.39h2.8099999999999996M7.98 18.24c.22 0 .39.18.39.39s-.16.38-.36.39H5.2c-.22 0-.39-.18-.39-.39s.16-.38.36-.39h2.8099999999999996M14.55 18.24c.22 0 .39.18.39.39s-.16.38-.36.39H9.37c-.22 0-.39-.18-.39-.39s.16-.38.36-.39h5.21M19.37 18.24c.22 0 .39.18.39.39s-.16.38-.36.39h-3.4299999999999997c-.22 0-.39-.18-.39-.39s.16-.38.36-.39h3.4299999999999997M22.28 6.13c.21 0 .38.16.39.36v11.6c0 .22-.18.39-.39.39s-.38-.16-.39-.36V6.52c0-.22.18-.39.39-.39" />
			<path d="M19.27 6.2c.21 0 .38.16.39.36v11.55c0 .22-.18.39-.39.39s-.38-.16-.39-.36V6.59c0-.22.18-.39.39-.39" />
			<path d="M22.27 17.71c.22 0 .39.18.39.39 0 1.05-.85 1.89-1.89 1.89s-1.89-.85-1.89-1.89c0-.22.18-.39.39-.39s.39.18.39.39c0 .61.5 1.11 1.11 1.11s1.11-.5 1.11-1.11c0-.22.18-.39.39-.39M3.95 4.24c.22 0 .39.18.39.39s-.18.39-.39.39c-.83 0-1.5.67-1.5 1.49 0 .22-.18.39-.39.39s-.39-.18-.39-.39c0-1.26 1.02-2.28 2.28-2.28Z" />
			<path d="M5.04 6.23c.22 0 .39.18.39.39 0 1.04-.84 1.88-1.88 1.88s-1.88-.84-1.88-1.88c0-.22.18-.39.39-.39s.38.16.39.36v.03c0 .61.49 1.1 1.1 1.1s1.1-.49 1.1-1.1c0-.22.18-.39.39-.39M22.26 6.23c.22 0 .39.18.39.39 0 1.04-.84 1.88-1.88 1.88s-1.88-.84-1.88-1.88c0-.22.18-.39.39-.39s.38.16.39.36v.03c0 .61.49 1.1 1.1 1.1s1.1-.49 1.1-1.1c0-.22.18-.39.39-.39" />
			<path d="M2.06 6.43c.21 0 .38.16.39.36v11.299999999999999c0 .22-.18.39-.39.39s-.38-.16-.39-.36V6.82c0-.22.18-.39.39-.39M5.07 6.2c.21 0 .38.16.39.36v11.729999999999999c0 .22-.18.39-.39.39s-.38-.16-.39-.36V6.59c0-.22.18-.39.39-.39" />
			<path d="M5.1 17.7c.22 0 .39.18.39.39a1.9 1.9 0 1 1-3.8 0c0-.22.18-.39.39-.39s.39.18.39.39c0 .62.5 1.12 1.12 1.12s1.1-.48 1.12-1.08v-.04c0-.22.18-.39.39-.39M17.25 4.5c.07-.2.3-.31.5-.24.19.07.3.28.24.47v.03l-.52 1.42c-.07.2-.3.31-.5.24a.387.387 0 0 1-.24-.47v-.03z" />
			<path d="M16.29 4.28c.19-.09.41-.01.51.17v.03l.66 1.42c.09.2 0 .43-.19.52s-.41.01-.51-.17v-.03L16.1 4.8c-.09-.2 0-.43.19-.52M15.08 16.86c.19-.09.41-.02.51.15v.02l.71 1.42c.1.19.02.43-.18.52-.19.09-.41.02-.51-.15v-.02l-.71-1.42c-.1-.19-.02-.43.18-.52" />
			<path d="M14.9 17.04c.1-.19.33-.27.52-.18s.27.31.19.5v.03l-.71 1.42c-.1.19-.33.27-.52.18s-.27-.31-.19-.5v-.03zM8.44 17.36c.17-.12.4-.09.53.06l.02.02.69.95c.13.17.09.42-.09.55-.17.12-.4.09-.53-.06l-.02-.02-.69-.95a.39.39 0 0 1 .09-.55" />
			<path d="M8.36 17.45c.13-.17.37-.21.55-.09.17.12.21.35.1.52l-.02.02-.69.95c-.13.17-.37.21-.55.09a.38.38 0 0 1-.1-.52l.02-.02zM10.44 4.44c.11-.19.35-.25.54-.14.18.1.25.33.16.51v.02l-.56.95c-.11.19-.35.25-.54.14a.39.39 0 0 1-.16-.51v-.02z" />
			<path d="M9.42 4.3c.17-.11.4-.07.52.1l.02.02.61.95c.12.18.06.42-.12.54-.17.11-.4.07-.52-.1l-.02-.02-.61-.95a.39.39 0 0 1 .12-.54M12.44 13.99c.15-.15.38-.15.53-.02l.02.02 1.41 1.41c.15.15.15.4 0 .55s-.38.15-.53.02l-.02-.02-1.41-1.41a.39.39 0 0 1 0-.55" />
			<path d="M13.85 13.99c.15-.15.4-.15.55 0s.15.38.02.53l-.02.02-1.41 1.41c-.15.15-.4.15-.55 0a.39.39 0 0 1-.02-.53l.02-.02z" />
		</svg>
	);
}
